/**
 * TYT Platform API
 * This is the TYT Platform API. It is used by TYT's apps to interact 
 * with the underlying platform. 
 *
 * NOTE: This file is auto generated. 
 * Do not edit this file manually.
 */


import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import * as models from '../model/models';
import { Requester } from '../requester';
import { PagedArray } from '../paged-array';

/* tslint:disable:no-unused-variable member-ordering */


@Injectable()
export class AuditLogsApi {
    constructor(
        protected requester: Requester
    ) {
    }

    /**
     * Get the list of audit logs for a piece of content
     * @param page 
     * @param klass 
     * @param id 
     */
    public getAuditLogs(page?: number, klass?: number, id?: number, __unused?: any): Observable<PagedArray<models.ApiAuditLog>> {
        const path = '/audit-logs/{klass}/{id}'
                    .replace('{' + 'klass' + '}', String(klass))
                    .replace('{' + 'id' + '}', String(id));

        let queryParameters : Record<string,string> = {};
        let headers : Record<string,string> = {}; 
        if (page !== undefined) {
            queryParameters['page'] = <any>page;
        }


        let requestMethodStr = 'RequestMethod.Get'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;

        return this.requester
            .request<PagedArray<models.ApiAuditLog>>(
                requestMethodStr, 
                requestPath, 
                queryParameters,
                headers,
            );
    }

}
